import React from 'react';
import Starfield from 'react-starfield';
import logo from './Season2Recruitment_SUMMER.jpg';   // ← your circle image
import aboutUs from './icons/about.svg';   // ← your circle image
import './App.css';
import PieMenu from "./PieMenu";
import SocialLinks from "./SocialLinks";
import merch   from './icons/tshirt.svg';
import team from './icons/teams.svg';
import events from './icons/events.svg';
import menu from './icons/menu.svg';
import stats from './icons/stats.svg';
import contact from './icons/contact.svg';

function App() {
  return (
    
    <div className="app-wrapper">
      
      <Starfield
        starCount={1000}
        starColor={[255, 255, 255]}
        speedFactor={.25}
        backgroundColor="black"
      />
       
      <div className="circle-container">
      <>
      <SocialLinks />
      {/* the rest of your layout */}
      <header>…</header>
      <main>…</main>
    </>
        <img src={logo} alt="Logof" className="center-logo" />
        <ul>
        <a href='test.com'>
          <li style={{ "--i": "#d670a2", "--j": "#ea51ff" }} className="link link-top">
            <span className="icon"><img src={aboutUs} alt="About US" className="center-icon" /></span>
            <span className="title">About</span>
          </li>
          </a>
          <a href='test.com'>
          <li style={{ "--i": "#d670a2", "--j": "#ea51ff" }} className="link link-l1">
            <span className="icon"><img src={merch} alt="About US" className="center-icon" /></span>
            <span className="title">Merch</span>
          </li>
          </a>
          <a href='test.com'>
            <li style={{ "--i": "#d670a2", "--j": "#ea51ff" }} className="link link-l2">
              <span className="icon"><img src={events} alt="About US" className="center-icon" /></span>
              <span className="title">Events</span>
              
            </li>
            </a>
            <a href='test.com'>
          <li style={{ "--i": "#d670a2", "--j": "#ea51ff" }} className="link link-l3">
            <span className="icon"><img src={menu} alt="About US" className="center-icon" /></span>
            <span className="title">Menu</span>
          </li>
          </a>
          <a href='test.com'>
          <li style={{ "--i": "#d670a2", "--j": "#ea51ff" }} className="link link-r1">
            <span className="icon"><img src={team} alt="About US" className="center-icon" /></span>
            <span className="title">Teams</span>
          </li>
          </a>
          <a href='test.com'>
          <li style={{ "--i": "#d670a2", "--j": "#ea51ff" }} className="link link-r2">
            <span className="icon"><img src={team} alt="About US" className="center-icon" /></span>
            <span className="title">Teams</span>
          </li>
          </a>
          <a href='test.com'>
          <li style={{ "--i": "#d670a2", "--j": "#ea51ff" }} className="link link-r3">
            <span className="icon"><img src={stats} alt="About US" className="center-icon" /></span>
            <span className="title">Stats</span>
          </li>
          </a>
          <a href='test.com'>
          <li style={{ "--i": "#d670a2", "--j": "#ea51ff" }} className="link link-bottom">
            <span className="icon"><img src={contact} alt="About US" className="center-icon" /></span>
            <span className="title">Contact</span>
          </li>
          </a>
         
          
      </ul>

      </div>

  <script type="module" src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"></script>
<script nomodule src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"></script>
    </div>
  );
}

export default App;
